/* eslint-disable import/prefer-default-export */
export function createStoreActions(service) {
  return {
    // Get all items from the endpoint
    async get({ commit }, params) {
      if (!service) throw new Error('No service specified!');

      const response = await service.get(params);

      const { status, data } = response;
      const { success, result = [], message = null } = data;

      if (!success) throw new Error(`Getting data failed with a status of ${status}!`, message);

      commit('set', result);
    },

    // Get a single item from the endpoint based on the id
    async getOne({ commit }, {
      id,
      mutate = true,
      type = 'id',
      parameters = {},
    } = {}) {
      if (!service) throw new Error('No service specified!');

      const item = await service.getOne(id, { type, ...parameters });

      const { result = null } = item.data;
      const data = typeof result === 'string' ? JSON.parse(result) : result;
      const params = { id: type === 'id' ? id : data.id, ...data };

      if (mutate) commit('add', params);

      return params;
    },

    async create({ commit }, { data, mutate = true } = {}) {
      if (!service) throw new Error('No service specified!');

      await service.create(data);

      if (mutate) commit('add', data);
    },

    async update({ commit }, { data, mutate = true }) {
      if (!service) throw new Error('No service specified!');

      await service.update(data);

      if (mutate) commit('update', data);
    },

    async delete({ commit }, id) {
      if (!service) throw new Error('No service specified!');

      await service.delete(id);

      commit('delete', id);
    },
  };
}
